<template>
  <div class="loader-container">
    <v-progress-circular :size="50" indeterminate></v-progress-circular>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.no-theme {
  @import "../assets/scss/_variables";
  .loader-container {
  color: $color-primary;
}
}

.theme-default {
  @import "../assets/scss/_variables";
  .loader-container {
  color: $color-primary;
}
}

.theme-black {
  @import "../assets/scss/_variables_black";
  .loader-container {
  color: $color-primary;
}
}

.theme-blue-gray {
  @import "../assets/scss/_variables_blue_grey";
  .loader-container {
  color: $color-primary;
}
}

.theme-blue {
  @import "../assets/scss/_variables_blue";
  .loader-container {
  color: $color-primary;
}
}

.theme-cyan {
  @import "../assets/scss/_variables_cyan";
  .loader-container {
  color: $color-primary;
}
}

.theme-dark-red {
  @import "../assets/scss/_variables_dark_red";
  .loader-container {
  color: $color-primary;
}
}

.theme-green {
  @import "../assets/scss/_variables_light_green";
  .loader-container {
  color: $color-primary;
}
}

.theme-light-green {
  @import "../assets/scss/_variables_green";
  .loader-container {
  color: $color-primary;
}
}

.theme-light-brown {
  @import "../assets/scss/_variables_light_brown";
  .loader-container {
  color: $color-primary;
}
}

.theme-lime-dark {
  @import "../assets/scss/_variables_lime_dark";
  .loader-container {
  color: $color-primary;
}
}

.theme-orange {
  @import "../assets/scss/_variables_orange";
  .loader-container {
  color: $color-primary;
}
}

.theme-pink {
  @import "../assets/scss/_variables_pink";
  .loader-container {
  color: $color-primary;
}
}

.theme-light-purple {
  @import "../assets/scss/_variables_purple_light";
  .loader-container {
  color: $color-primary;
}
}

.theme-purple {
  @import "../assets/scss/_variables_purple";
  .loader-container {
  color: $color-primary;
}
}
.loader-container {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgb(122 133 191 / 35%);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>